import { DvFormSection, DvFormUtil, FormOf } from '@devinco/ui/dds';
import { VtFormElement } from '../interfaces/form.element';
import { FormGroup } from '@angular/forms';

export default class FormUtils {
  static getKeysForRequest(elements: VtFormElement<any>[]): string[] {
    return elements
      .filter(
        (
          el
        ): el is VtFormElement & {
          formControlParams: { key: string };
        } =>
          typeof el.formControlParams?.key === 'string' &&
          el.extra?.ignoreInRequest !== true
      )
      .map(el => el.formControlParams.key);
  }

  /** Builds a FormGroup from an array of FormSection objects. */
  static buildFormGroupFromSections<TData = any>(
    sections: DvFormSection[]
  ): FormGroup<FormOf<TData>> {
    const allElements = sections.flatMap(section => section.elements);
    return DvFormUtil.buildFormGroup(allElements);
  }
}
